import React from "react"
import { Box, useMediaQuery, useTheme, Paper } from "@material-ui/core"
import useStore from "src/v2/utils/store"
import useASTStore from "../../utils/AST-store"
import GraphViewer from "./graph-viewer/graph-viewer"
import FileViewer from "./file-viewer/file-viewer"
import Resizable from "../ui-components/resizable/resizable"
import ResizableContainer from "../ui-components/resizable/resizable-container"

export default function ArchitectureDiagram() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.down("md"))
  const oneReview = useStore((state) => state.oneReview)
  const solFiles = oneReview?.analyzedData?.solFiles || []
  const initialFile = oneReview?.mainFileName || (solFiles[0]?.path || "")
  const setSelectedFile = useASTStore((state) => state.setSelectedFile)
  const goto = useASTStore((state) => state.goto)
  const graphWidth = useASTStore((state) => state.architectureGraphWidth)
  const setGraphWidth = useASTStore((state) => state.setArchitectureGraphWidth)
  const graphData = oneReview?.analyzedData?.graphData

  const onResourceClick = (resource) => {
    if (resource.declaredInFile) {
      setSelectedFile(resource.declaredInFile)
    }
    if (resource.declaredInFile && resource.line) {
      setTimeout(() => {
        goto(resource.declaredInFile, resource.line)
      })
    }
  }

  if (!graphData) {
    return (
      <Paper style={{ padding: 24, minHeight: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
        No architecture data available.
      </Paper>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      width="100%"
      height="100%"
      minHeight={isMobile ? 600 : isTablet ? 500 : 400}
      style={{ background: "#f6f6fa" }}
    >
      <ResizableContainer direction={isMobile ? "column" : "row"}>
      <Resizable
        disabled={isMobile}
        size={graphWidth}
        defaultSize="50%"
        minSize={200}
        minRemaining={200}
        onResize={setGraphWidth}
        style={{
          background: "#fff",
          minHeight: isMobile ? 300 : isTablet ? 500 : 900,
        }}
      >
        <GraphViewer
          graphData={graphData}
          onResourceClick={onResourceClick}
        />
      </Resizable>
      <Box
        flex={1}
        minWidth={isMobile ? "100%" : 0}
        style={{
          background: "#f6f6fa",
          minHeight: isMobile ? 200 : 300,
          padding: 0,
        }}
      >
        <FileViewer solFiles={solFiles} initialFile={initialFile} />
      </Box>
      </ResizableContainer>
    </Box>
  )
}